/* eslint-disable max-lines */
import { EcsProjectTeamName } from '../types';

export type Experiment =
  | 'AddDelegateAPIMigration'
  | 'AdminMutePosts'
  | 'AdminMuteUser'
  | 'AdhocAudienceAnnouncement'
  | 'AdhocAudiencePickerCustomGroups'
  | 'AdminRoleManagement'
  | 'AdminRoleManagementPostGa'
  | 'AdvancedModeration'
  | 'AISuggestedPublisherPrompt'
  | 'AnonymousAmaReplies'
  | 'AnswerCommunitySearchUX'
  | 'AnswersAISuggestedCommunities'
  | 'AnswersCommunityAISuggestedTopics'
  | 'AnswersForager'
  | 'AnswersForagerGroups'
  | 'AnswersInVivaGA'
  | 'AnswersToggle'
  | 'AnswersUpdates'
  | 'ArticleAutoGeneratedHeaderImage'
  | 'ArticleInlineGifs'
  | 'ArticleInlineVideos'
  | 'ArticleOpenSameWindow'
  | 'ArticleForSuggestedContent'
  | 'ArticleTableofContents'
  | 'AtMentionCustomName'
  | 'AutoSuggestionCampaignHashtag'
  | 'BackendCellOverride'
  | 'BackendGraphqlApiVnextEndpoint'
  | 'BackendGraphQLApiVNextRolloutAlpha'
  | 'BackendGraphQLApiVNextRolloutBeta'
  | 'BackendGraphQLApiVNextRolloutCanary'
  | 'BackendGraphQLApiVNextRolloutDogfood'
  | 'BackendGraphQLApiVNextRolloutProd25'
  | 'BackendGraphQLApiVNextRolloutProd50'
  | 'BackendGraphQLApiVNextRolloutProd100'
  | 'BackendLiveEventFeedCaching'
  | 'BackendLiveEventFeedCachingByTenant'
  | 'BackendOcularCosmos'
  | 'BackendStreamieCosmos'
  | 'BellPageSize'
  | 'BespokeCommunityCreateEdit'
  | 'BestAnswerNudge'
  | 'BookmarkThread'
  | 'CampaignPrivateMessage'
  | 'CKRelayReplyPublisher'
  | 'CampaignSashAvatar'
  | 'CampaignsCoOrganizers'
  | 'CampaignExecutiveSponsorRefinement'
  | 'CampaignsExecutiveSponsorship'
  | 'CampaignsHub'
  | 'CampaignHoverCard'
  | 'CampaignFollowerDetails'
  | 'CommsDashboardConversations'
  | 'CommunityAgent'
  | 'CommunityBadgeAdmin'
  | 'CommunityCampaigns'
  | 'CommunityCoachTips'
  | 'CommunityExperts'
  | 'CommunityFeatureConversation'
  | 'CommunityInfoEdit'
  | 'CommunityInsightsV2ThreadMetrics'
  | 'CommunityInsightsSentimentAndThemes'
  | 'CommunityLeads'
  | 'CommunityLeadsAndAutoPin'
  | 'CommunityManagerSubscriptionTip'
  | 'CommunityMultiPinThreads'
  | 'CommunityPublisherDeferredLoading'
  | 'CommunityRelayBanner'
  | 'CommunityRelayDataLoader'
  | 'CommunitySettingsPage'
  | 'CommunitySetupTeachingBubbles'
  | 'CommunitySidebarReorderStatic'
  | 'CommunitySubscriptionBubbleOnly'
  | 'CommunityTopQuestions'
  | 'CompactHeaderGeneral'
  | 'CompactHeaderStoryline'
  | 'CompanyLogoInLCHeader'
  | 'MTOCampaignAnalytics'
  | 'CampaignEngageDigest'
  | 'CampaignAnalyticsNetworkFilter'
  | 'CampaignTargeting'
  | 'CampaignTargetingV2'
  | 'CondensedQuestionFeed'
  | 'ConversationInsightsV2ThemeSummarization'
  | 'CopilotCommunityConversion'
  | 'CSVUploadGroupMembers'
  | 'DelegateRequest'
  | 'DelegateStorylineAccessAPIMigration'
  | 'DelegateRequestBell'
  | 'DisablePollPostType'
  | 'DiscoverCommunitiesV2'
  | 'DiscoverOfficialCommunities'
  | 'DivisionalBespokeCommunity'
  | 'DogfoodPerfHUD'
  | 'DomainMigration'
  | 'DraftSorting'
  | 'DraftPublisherWithCopilot'
  | 'ECDNSupportForEvents'
  | 'EnableDeleteOptions'
  | 'EngageMetaOsTranslationOverrides'
  | 'EngageSegmentationAdminPage'
  | 'EngageWebTranslationOverrides'
  | 'EmbedSupportForNetworkContext'
  | 'EnhancedDigestDiscoveryDesign'
  | 'EventsPrivateRepliesSortRecentActivity'
  | 'ExpertsCanSwitchPostType'
  | 'ExpertSelfNomination'
  | 'ExtendedUnSeenCountEnabled'
  | 'FAQIfy'
  | 'FAQIfyAnswersCommunity'
  | 'FavoritesDragDropReorder'
  | 'FeaturedTeamsMeetingsV2'
  | 'FeedLoadNumThreads'
  | 'FeedLoadMoreNumThreads'
  | 'FeedVirtualization'
  | 'FilesCookielessAuth'
  | 'FollowButtonHomeFeedThreadWithGreyColor'
  | 'GlobalCopilotQueryWarmupSignal'
  | 'GroupFeedFilterAndSortByExp'
  | 'GroupHoverCardV2'
  | 'GroupsFromGrouper'
  | 'HideFilesRelatedResources'
  | 'CommunityResourcesCardVisibilitySetting'
  | 'CommunityFilesTabVisibilitySetting'
  | 'HomeFollowingFeed'
  | 'HydrantOptionsRefactoring'
  | 'HydrateAnswersTopicsAsync'
  | 'IFrameSandboxForSharePointVideoCard'
  | 'ImageBlobification'
  | 'ImageCompressionWeb'
  | 'InFeedUserSuggestions'
  | 'IntelligentImporterBulkDelete'
  | 'IntelligentImporterDeleteOnPublish'
  | 'IntelligentImporterCopilotAdoptionCommunities'
  | 'KnowledgeBespokeCommunity'
  | 'LeaderAudienceFeed'
  | 'LeaderDashboard'
  | 'LeadersViewDelegation'
  | 'LeaderGroupsAddAsync'
  | 'LeaderManagementActivityLog'
  | 'LeaderOptionWebpart'
  | 'LeadersAudienceM365Support'
  | 'LeadershipCornerPinnedPosts'
  | 'LightboxFollowUsers'
  | 'LimitConversationMoveSettingsAndFilter'
  | 'LiveEventsScaleLoadPerf'
  | 'LoadThreadDataWhileRouting'
  | 'LoadFeedDataWhileRouting'
  | 'LogProtobufEvents'
  | 'M365CopilotAdoption'
  | 'M365CopilotAdoptionRelatedQuestions'
  | 'M365CopilotAdoptionSuggestedMembers'
  | 'M365CopilotAdoptionTopQuestions'
  | 'MicrosoftDesignerApp'
  | 'MinimalWFPayloadOnReplyPosting'
  | 'MessagesReactionsAPI'
  | 'MobileCrossSellThreadViewV2'
  | 'ModerationDetectedConversations'
  | 'ModerationThemeDetectedEmailNotification'
  | 'DigitalSafety'
  | 'MTOAdminToggle'
  | 'MTOBadge'
  | 'MTOBlendedInbox'
  | 'MTOCampaigns'
  | 'MTOCommunity'
  | 'MTOGraphVNextResolvers'
  | 'MTOOpenResourceUrl'
  | 'MTOPolicyEngageAdminPortalPage'
  | 'MTOStoryline'
  | 'EnablePermalinkDeeplink'
  | `MultiTenantOrganization`
  | 'MultiLanguagePublisher'
  | 'MutedVideoAutoPlay'
  | 'MyGroupsAdminOfFilter'
  | 'NestedBestReply'
  | 'NetworkInsightsHRFilters'
  | 'NetworkQuestionsInConversations'
  | 'NotificationsReplatform'
  | 'NoWFMessageBodyInGroupMessageCreationResponse'
  | 'OdspFilePickerType'
  | 'OfficeTopics'
  | 'OneCameraV3'
  | 'OnePlayer'
  | 'OnePlayerV2'
  | 'OnePlayerNative'
  | 'OpenPublisherWithModal'
  | 'OpenPublisherWithCopilotModal'
  | 'OptimizedReactionsFetching'
  | 'OWADigestsThreadsReduction'
  | 'PeopleSuggestion3SV3'
  | 'PinnedFiles'
  | 'PollsSchedule'
  | 'PostOnBehalfOfCommunityHomePublisher'
  | 'PrefilledDefaultAudience'
  | 'PrivateReplies'
  | 'PrivateRepliesAMA'
  | 'PrivateRepliesEditPendingThreads'
  | 'PrivateRepliesQnANotifications'
  | 'PublisherAbandonmentOCVSurvey'
  | 'PublisherClientSideSaveDraft'
  | 'PublisherSuggestedTopics'
  | 'PublisherV2'
  | 'PWALegacyBrokenExperience'
  | 'PWALegacyDeprecation'
  | 'QuestionsQueue'
  | 'LeadersSettingCard'
  | 'QuestionTitles'
  | 'QuestionTitlesV2'
  | 'QuestionTitlesV3'
  | 'QuickNavManageMyThings'
  | 'ReactionSimplification'
  | 'ReadOnlyMode'
  | 'RecommendationBarCampaignFollowBtn'
  | 'RemoveDelegateAPIMigration'
  | 'RemoveTopicsSDKDependencyForVivaTopicsInFeeds'
  | 'ReportConversationMigration'
  | 'ReportLongAnimationFrameTiming'
  | 'RestrictedUser'
  | 'RestrictPostingAnyGroupRollout'
  | 'RoleBasedFRE'
  | 'SearchAllResultsTab'
  | 'SearchDiscoverabilityFRE'
  | 'SearchFiltersRefresh'
  | 'SearchAutocompleteResultsGroupFirst'
  | 'SearchWithCopilot'
  | 'SeededLeader'
  | 'ServerSharePointWebLinks'
  | 'ShareAMAPoboToStoryline'
  | 'SharePointTempAuthUrlDeprecation'
  | 'SharePointTempAuthUrlDeprecationByTenant'
  | 'SharePointVideoLinkPreviews'
  | 'ShowUserCoverImage'
  | 'SimplifyExpertVerification'
  | 'SmallFileUpload'
  | 'SplitDataAndPresentationComponents'
  | 'Stories'
  | 'StoriesPostOnBehalfOfEnabled'
  | 'StoriesV2Cards'
  | 'StorylineAnnouncementAudienceChannelsConfigEnabled'
  | 'StorylineAnnouncementNotificationUrgency'
  | 'StorylineAnnouncementTeachingBubbleAndDisableInfobar'
  | 'StorylineAnnouncementTeamsEmailChannelsEnabled'
  | 'StorylineAsDefaultOnHomePublisher'
  | 'StorylineDefaultHomeFeedPublisherLongv2'
  | 'StorylineDefaultHomeFeedPublisherShortv2'
  | 'StorylineDirectAndDigestRebrand'
  | 'StorylineFeatureConversation'
  | 'StorylineFollowBack'
  | 'StorylineFREVivaEngage'
  | 'StorylineMediaPost'
  | 'StorylineMediaPostGA'
  | 'StorylinePerUserControl'
  | 'StorylinePublisherCoachingTips'
  | 'StorylinePublisherSettingsNetworkCall'
  | 'StorylinePublisherTipsLongV3'
  | 'StorylinePublisherTipsShortV3'
  | 'StorylineThreadCoachingTips'
  | 'StorylineThreadTipsLongV3'
  | 'StorylineThreadTipsShortV3'
  | 'StreamLiveEventDeprecationExtension'
  | 'ExternalNetworksAdminPage'
  | 'SuggestedThemes'
  | 'SystemInitiatedEngageFeedback'
  | 'TBENestedAuthAppSupport'
  | 'TBEBackgroundLoadApp'
  | 'TeamsBackButton'
  | 'TeamsClientDataLayer'
  | 'TeamsBrandedExperiencesCommunityFeatures'
  | 'TeamsBrandedExperiencesEvents'
  | 'TeamsBrandedExperiencesLastReadBar'
  | 'TeamsBrandedExperiencesOpenStorylineTab'
  | 'TeamsBrandedExperiencesServiceWorker'
  | 'TeamsBrandedExperiencesUseEngageCoachmarks'
  | 'TeamsBrandedExperiencesFREShowLearnMore'
  | 'TeamsBrandedExperiencesFilesTab'
  | 'TeamsFocusCommandsInEngageApp'
  | 'TeamsMeetingAccess'
  | 'TeamsMeetingArchiveFeature'
  | 'TeamsMeetingDisableReactionsOption'
  | 'TeamsMeetingMaskIdentitiesBanner'
  | 'TeamsMetaOSNestedAuthAppSupport'
  | 'TeamsPageLoadSuccessTiming'
  | 'TeamsQnAFeedReset'
  | 'TeamsQnAMessageReactions'
  | 'TeamsQnANestedAuthAppSupport'
  | 'TeamsQnAPostAsModerator'
  | 'TeamsQnAPostAsModeratorNotifications'
  | 'TeamsQnAPostAsModeratorSenderDetails'
  | 'TeamsQnAReloadMeetingOnCacheResume'
  | 'TeamsQnAThreadUpvote'
  | 'TeamsQnAVivaEngageAmaRedesign'
  | 'TeamsQnAUXUpdatesDeprecated'
  | 'TeamsTownhallEventInVivaEngage'
  | 'TeamsUserInitiatedEngageFeedback'
  | 'ThirdPartyCookieFix'
  | 'ThreadCopyLinkV2'
  | 'TopicSegmentationV1'
  | 'UCBSquareDesign'
  | 'UseBatchedFiles'
  | 'UserGroupsFromGrouper'
  | 'UserInitiatedEngageFeedback'
  | 'UserSettingsNotificationsLoader'
  | 'UserSettingsPageCrossPlatform'
  | 'UniversalCreateButtonV3'
  | 'UniversalCreateButtonWithQuestion'
  | 'VerifiedAnswers'
  | 'TranslationOverrides'
  | 'VivaAppBar'
  | 'VivaEngageAdminBanner'
  | 'VivaEngageAmaBestAnswerRedesign'
  | 'VivaEngageAmaRebrand'
  | 'EventAnonymousPosting'
  | 'PremiumEventExperience'
  | 'PrivatePremiumEventCreation'
  | 'VivaEngageCollapsiblePanelRecommendations'
  | 'VivaEngageCopilotBE'
  | 'VivaEngageCopilotCatchUpPlugin'
  | 'VivaEngageCopilotDebug'
  | 'VivaEngageCopilotWAGpt4'
  | 'VivaEngageCopilotWAPersonalized'
  | 'VivaEngageCoverImage'
  | 'VivaEngageDeepLinkFromOWA'
  | 'VivaEngageAugLoopEnvironment'
  | 'VivaEngageGlobalCopilot'
  | 'VivaEngageLC'
  | 'VivaEngageOfficeAICopilot'
  | 'VivaEngagePremium'
  | 'VivaEngageQnAFastFollow'
  | 'VivaEngageRebrandingAdminBanner'
  | 'VivaEngageRebrandingBanner'
  | 'VivaEngageSearchPlugin'
  | 'VivaEngageTeamsLiveEventMobile'
  | 'VivaGoals'
  | 'VivaGoalsConfig'
  | 'VivaGoalsOverride'
  | 'VivaLeadershipChronoFeed'
  | 'VivaLeadershipCuratedFeed'
  | 'UnseenThreadStarterInInbox'
  | 'YamJSEOLUnsubscribe'
  | 'ArticleSuggestionBar'

  // Existing experiments that incorrectly have 'Enabled' as part of their name.
  // Do not do this - 'enabled' should be |of an experiment not part of the name.
  // The name should instead focus on describing the feature/functionality affected.
  // Since these are |and in use we |t rename them so just have
  // to let them run their course.
  | 'CortexTopicCardsEnabled'
  | 'LiveEventSortingChangeEnabled'
  | 'ModulatorGroupSuggestionsEnabled'

  // Experiments used for testing the experiment infrastructure - grouping
  // these separately from the regular feature experiments above. Regular
  // experiments should not have the name 'experiment' in them.
  | 'ClientForwardExperimentForTesting1'
  | 'ClientForwardExperimentForTesting2'
  | 'CrossPlatformExperimentForTesting1'
  | 'CrossPlatformExperimentForTesting2'
  | 'ExperimentForTesting1'
  | 'ExperimentForTesting2';

export type ExperimentTreatmentValue = string | boolean | number;

export interface ExperimentConfig {
  readonly id: string | undefined;
  readonly projectTeam: EcsProjectTeamName;
  readonly treatments: ExperimentTreatmentValue[];
  readonly defaultTreatment: ExperimentTreatmentValue;
}

export const experimentConfigs: ExperimentConfigs = {
  AISuggestedPublisherPrompt: {
    id: '723913fc-0efb-4ffd-9a08-4fad53169a6b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdminMutePosts: {
    id: '33e428a9-6f7b-4e6c-837d-058f0fa45f57',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdminMuteUser: {
    id: '58c15c56-4f98-496f-baad-210c30c76973',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AddDelegateAPIMigration: {
    id: 'e0624a4a-09cd-4506-83a8-e6b61da2ff7a',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdhocAudienceAnnouncement: {
    id: 'e00edc3f-f7d1-483f-affe-81309a599485',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdhocAudiencePickerCustomGroups: {
    id: 'd1d516a8-11d8-4fa7-ba2d-242be3da2f9c',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdminRoleManagement: {
    id: 'df4c49e2-1204-4a2e-8c25-ecf42b53cdca',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdminRoleManagementPostGa: {
    id: 'a6fc3318-67c4-491f-b792-9e4afe99ecce',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdvancedModeration: {
    id: 'df1220fe-e8ff-4fd1-b8bf-68d539f7838b',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnonymousAmaReplies: {
    id: '16175b09-aa37-4fba-8e0d-7a42b93ea302',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersAISuggestedCommunities: {
    id: '82c5b20f-058b-4953-a99e-f46bcdb3a0ae',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersCommunityAISuggestedTopics: {
    id: '0cdf41c9-ce56-4c30-a3b8-e557b3a7b78f',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswerCommunitySearchUX: {
    id: '4435a113-a41e-4a86-9517-5877cc008ab7',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersForager: {
    id: 'e86fc706-4e92-4fa3-8376-199716e811ee',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersForagerGroups: {
    id: '18278c4f-67a3-4760-b90c-ba4e80253582',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersInVivaGA: {
    id: '380a21a6-bc1e-4619-aa37-f11e947f9844',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersToggle: {
    id: '4235a1a4-f403-4426-b53d-889880fb51a4',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersUpdates: {
    id: '4f9555aa-a589-487f-8b8b-a8a43fa3b9ab',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleAutoGeneratedHeaderImage: {
    id: '93665fdb-9c42-4d42-83c7-369072341b1d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleInlineGifs: {
    id: 'b77b6e6d-993f-4970-8978-75fb1d7aede1',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleInlineVideos: {
    id: '48ed1aec-6e61-47a7-80a2-bd0834c444f0',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleOpenSameWindow: {
    id: '21fcb795-ea10-4bbe-acd9-85bf9df90dd8',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleForSuggestedContent: {
    id: '6ac32613-5bcd-42d3-8d01-58f1b46af752',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AtMentionCustomName: {
    id: '0f7581eb-ad8e-4acc-80fa-75214dd00bed',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AutoSuggestionCampaignHashtag: {
    id: 'acc4854f-ed9d-4082-8f56-5f2bba1d2bed',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendCellOverride: {
    id: '04405bd5-cbd9-4234-96a0-e715d6901d66',
    projectTeam: 'ClientForward',
    treatments: ['control', 'c1', 'c2', 'c3', 'c4', 'c5'],
    defaultTreatment: 'control',
  },
  BackendGraphQLApiVNextRolloutAlpha: {
    id: '72b2edd7-fd66-4600-a011-86620b31f326',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutBeta: {
    id: 'b04de4f5-3243-4ada-83d2-b959f33c7323',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutCanary: {
    id: '97d4aa63-c7cb-4fa1-9e5b-0ad05f882d74',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutDogfood: {
    id: 'c4970364-0977-4f25-98fc-363b12db5aea',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutProd25: {
    id: 'e7982880-04ae-432a-99b8-373bea07f6a1',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutProd50: {
    id: 'f6ef418e-6d13-4403-aed1-bedd19875a95',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersSettingCard: {
    id: '60615d03-433d-468a-8753-c889e4777325',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutProd100: {
    id: '8b86d14a-6f85-4598-b877-9c433560afcb',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphqlApiVnextEndpoint: {
    id: 'fd389c01-9fdd-440d-af71-41aab31f2a57',
    projectTeam: 'CrossPlatform',
    treatments: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    defaultTreatment: 2,
  },
  BackendLiveEventFeedCaching: {
    id: '298a9ad9-4a09-4bc9-b03c-57409c423b7e',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendLiveEventFeedCachingByTenant: {
    id: 'cf0d025e-c359-4988-8ab4-abed3a5f7e77',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendOcularCosmos: {
    id: '6efb151f-2e3b-466f-9fac-d14928e0d815',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  BackendStreamieCosmos: {
    id: '13753d6c-0a9e-4927-bf80-524e4fb99bba',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BellPageSize: {
    id: '5d034307-8927-41cc-bdc1-2b9b000bc466',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },

  BespokeCommunityCreateEdit: {
    id: '63d38f2f-36df-4d03-b8ed-fa4f7e07b48f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BestAnswerNudge: {
    id: '35fd2574-e8f8-46e2-a09e-f900eaabcadc',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  BookmarkThread: {
    id: '73b842f4-791f-4157-a5b2-76917957057f',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CampaignHoverCard: {
    id: '8302d48b-9695-4ebc-b5f6-ce2627cd0995',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsHub: {
    id: 'aefbd4b4-7240-4368-a057-35889afef9d3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsCoOrganizers: {
    id: 'c10ce8d9-b5ee-49cb-b815-544393f57c5e',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsExecutiveSponsorship: {
    id: '671d7ef6-08c8-4643-84c6-be6fe85d3df3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignExecutiveSponsorRefinement: {
    id: 'e346f173-4cc4-4dc4-b786-ea71c72f0c90',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignFollowerDetails: {
    id: '0b6a86fb-6f38-45fc-b33c-c148670f7e92',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignSashAvatar: {
    id: '16cd896a-947c-4767-ad07-d12496b328ad',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignPrivateMessage: {
    id: '908d243c-add7-4cae-b2f2-dae99cc15de3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CKRelayReplyPublisher: {
    id: '1688beca-32db-46d2-82d0-0e2e8d7e65cf',
    projectTeam: 'YammerClients',
    treatments: ['control', 'ckrelay', 'debug'],
    defaultTreatment: 'control',
  },
  CommsDashboardConversations: {
    id: '287f1f87-5315-49c3-9a0e-f38fdc657849',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityAgent: {
    id: '3fb68049-c9fb-4b14-8984-12e1ca99255e',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CommunityBadgeAdmin: {
    id: 'ace0c8c8-713f-433d-9807-2617506e7cbb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityCampaigns: {
    id: '4f8ed957-4e32-4dcd-be65-39c5361403e6',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityCoachTips: {
    id: '45107b86-6a6f-4842-bd70-e3b9469361e6',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityExperts: {
    id: 'c544340c-0b40-4f2e-9659-25e58bdd04ed',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CommunityFeatureConversation: {
    id: '40ad4c65-5ac7-4f59-bf4f-7b4fde1f1883',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityInfoEdit: {
    id: 'ee069b70-8cda-4cdd-bd3b-b8ea94cc7ca5',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityInsightsV2ThreadMetrics: {
    id: '1f6924f8-eebd-44f3-9bde-8d3e92b1dd95',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityInsightsSentimentAndThemes: {
    id: '7d529b90-462e-47f9-b949-e1e03c5ec19c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityLeads: {
    id: '25f7fc54-ecbd-495e-9014-3bae205e8f91',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityLeadsAndAutoPin: {
    id: 'beae692c-0343-4008-8003-64d56a4b8f19',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityManagerSubscriptionTip: {
    id: '44568163-115a-4170-b9c8-0314dab7745d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityMultiPinThreads: {
    id: 'acf83872-e4e4-4d0b-a382-ec73b02ffc50',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityPublisherDeferredLoading: {
    id: 'b11a1bb3-9eaa-4145-84fb-f9eae2b6e132',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityRelayBanner: {
    id: 'db5c0e91-2fa0-47a7-81c5-81a451f2e0e9',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityRelayDataLoader: {
    id: '77c8c9d4-133c-4f72-a0e5-682f46dba497',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySettingsPage: {
    id: 'b050044d-86ef-45c6-985e-d8af5184405c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySetupTeachingBubbles: {
    id: '9665f8af-afb7-4f17-83d6-dcaa4e7ea275',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySidebarReorderStatic: {
    id: 'fa840604-fb43-466d-aa22-ead855fc7a46',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySubscriptionBubbleOnly: {
    id: '62b198ee-a1ea-4235-af37-36e43c16942c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityTopQuestions: {
    id: '2556a0dd-f9d5-484b-b7d5-a478a9f562f0',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CompactHeaderGeneral: {
    id: '3a8152dc-3f83-4334-ad84-be9acbbdb504',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompactHeaderStoryline: {
    id: 'affd7fb3-e3d6-4e99-968e-786e19ff8295',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignAnalyticsNetworkFilter: {
    id: '4400d642-201a-446c-94c8-75811af8f690',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignTargeting: {
    id: 'f86439d9-fddb-4af1-a506-a7984476c5c6',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignTargetingV2: {
    id: '4d59a1d3-1448-4c84-9816-7653768ab854',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOCampaignAnalytics: {
    id: 'a863078e-bddf-48f6-aab4-bff771ca0497',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignEngageDigest: {
    id: 'a2a7200d-c2fc-4921-8c62-f30be781d08f',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompanyLogoInLCHeader: {
    id: 'ca32a32d-1b98-44ab-87fc-de35ef47838e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CortexTopicCardsEnabled: {
    id: 'ae26490b-84e4-4c54-b485-97dafc981ec2',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CondensedQuestionFeed: {
    id: '5bcf59f7-1b56-4445-8af4-6c373d676591',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ConversationInsightsV2ThemeSummarization: {
    id: '8a930c50-189c-463b-b798-fc35202e2ba4',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CopilotCommunityConversion: {
    id: '121f2bb4-d221-457c-ad66-add8bef178eb',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CSVUploadGroupMembers: {
    id: 'c435b040-40d3-4e6d-98ec-321f6229e34d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ClientForwardExperimentForTesting1: {
    id: undefined,
    projectTeam: 'ClientForward',
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  ClientForwardExperimentForTesting2: {
    id: undefined,
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CrossPlatformExperimentForTesting1: {
    id: undefined,
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  CrossPlatformExperimentForTesting2: {
    id: undefined,
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DelegateRequest: {
    id: 'a95b95cb-8a11-449b-9add-7ef53c519768',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DelegateStorylineAccessAPIMigration: {
    id: 'c78366ca-c40e-44c3-a05f-990d9f463d1c',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DelegateRequestBell: {
    id: '0708fb57-3c0b-4fa9-90e7-cea437075642',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DisablePollPostType: {
    id: '57738844-f4ad-4e10-bc25-8b1736ceae70',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DiscoverCommunitiesV2: {
    id: '39b449a2-1fd5-4599-89d0-e2a86a1a16a5',
    projectTeam: 'YammerClients',
    treatments: ['disabled', 'enabled'],
    defaultTreatment: 'disabled',
  },
  DiscoverOfficialCommunities: {
    id: 'b1de80d6-8d37-4ac3-980e-22264edb9654',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DivisionalBespokeCommunity: {
    id: '6f9c3ced-854b-4bc2-9af3-7db4be804007',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DogfoodPerfHUD: {
    id: 'f99f0b6b-0761-47b3-b436-28a004d68b30',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DomainMigration: {
    id: 'af478543-716d-4c0f-8233-eb60a9a38e20',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftSorting: {
    id: '98e0ca69-7b24-4ce1-a33b-705b2fd15cbd',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftPublisherWithCopilot: {
    id: 'f8124b33-1668-4c7b-937a-143c9b9d88d4',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ECDNSupportForEvents: {
    id: 'f94e0329-f9f9-4635-bea5-f5f91e0a5e63',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EnableDeleteOptions: {
    id: 'd3c72095-a654-4ba6-bf11-380b9cd63c3d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EmbedSupportForNetworkContext: {
    id: 'cd378d7c-89b3-4b1c-9f8c-654569e2eff5',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EngageMetaOsTranslationOverrides: {
    id: 'ab41ddd4-d8c0-4121-b4b6-5856c92c686e',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enable_all'],
    defaultTreatment: 'control',
  },
  EngageSegmentationAdminPage: {
    id: '11f52907-db20-4d68-bcf2-225b933385e9',
    projectTeam: 'ClientForward',
    treatments: [0, 1, 2, 3],
    defaultTreatment: 0,
  },
  EngageWebTranslationOverrides: {
    id: '67c92527-9e94-499a-8fbd-3bdd47c6d7cf',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enable_all'],
    defaultTreatment: 'control',
  },
  EnhancedDigestDiscoveryDesign: {
    id: '281e84a8-537f-4440-93e2-9b7c91289a99',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'all_surfaces', 'list_view', 'reading_pane'],
    defaultTreatment: 'control',
  },
  EventsPrivateRepliesSortRecentActivity: {
    id: '107c70fb-40f9-4102-9202-9216c640ee00',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ExperimentForTesting1: {
    id: 'fake-guid-for-testing',
    projectTeam: 'YammerClients',
    treatments: ['control', 't1'],
    defaultTreatment: 'control',
  },
  ExperimentForTesting2: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ExpertsCanSwitchPostType: {
    id: '18f0ab1f-aac3-4012-8605-6ebf33dd5631',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ExpertSelfNomination: {
    id: 'dbe66e70-dabc-4e68-a8ac-4c96e099b51e',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ExtendedUnSeenCountEnabled: {
    id: '203aa725-6970-4a9e-aa58-0e1a9ddff681?',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  FAQIfy: {
    id: '841a0b15-388f-4059-9b18-4065835cff5d',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  FAQIfyAnswersCommunity: {
    id: 'f339f29f-1933-442e-b9cd-9a887d7534da',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  FavoritesDragDropReorder: {
    id: '83593909-57d5-49e8-b3f4-eca2e2c142d2',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  FeaturedTeamsMeetingsV2: {
    id: '43cf2e87-8b85-4460-9117-0265c52bcd14',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  FeedLoadNumThreads: {
    id: 'ff83b0e2-9375-4aaa-9805-c9b8ac90c97b',
    projectTeam: 'YammerClients',
    treatments: [4, 3, 2, 1],
    defaultTreatment: 4,
  },
  FeedLoadMoreNumThreads: {
    id: '2a5e8839-400e-4152-80a4-c1c73fb07eeb',
    projectTeam: 'YammerClients',
    treatments: [4, 3, 2, 1],
    defaultTreatment: 4,
  },
  FeedVirtualization: {
    id: '6bd3be91-2927-4542-817e-80feb2de4390',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  FilesCookielessAuth: {
    id: '63a5ce7d-ecb2-4090-a988-77b39994f4d7',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  FollowButtonHomeFeedThreadWithGreyColor: {
    id: '440bb634-1b43-44c8-9251-e9d02a469570',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  GlobalCopilotQueryWarmupSignal: {
    id: '8d4daa69-112f-407e-a580-e667b3f9033a',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  GroupFeedFilterAndSortByExp: {
    id: 'cff752e6-7035-4cd5-9264-d6340d64b3d9',
    projectTeam: 'YammerClients',
    treatments: ['all_recent_posts', 'default'],
    defaultTreatment: 'default',
  },
  GroupsFromGrouper: {
    id: '49b25bb2-375e-46ce-8624-6224d5254df0',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  HideFilesRelatedResources: {
    id: '50a6f470-346b-4b74-b21d-8f7fe1eb15c6',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityResourcesCardVisibilitySetting: {
    id: '99b72a5f-7eef-46f7-a5c6-7c03bb4c8c41',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityFilesTabVisibilitySetting: {
    id: 'be1a0c0e-29d3-4bac-99fb-73b8f3e837fd',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  HomeFollowingFeed: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  IFrameSandboxForSharePointVideoCard: {
    id: '76d544b1-f002-49ff-82dd-b9aeb6344f0d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  InFeedUserSuggestions: {
    id: 'edc8645c-a10d-4ab1-aab3-34842a682c5d',
    projectTeam: 'ClientForward',
    treatments: ['control', 'rankie', 'enabled'],
    defaultTreatment: 'control',
  },
  GroupHoverCardV2: {
    id: 'e22b6ca1-ad23-4176-afbf-ab7b9365648e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  HydrantOptionsRefactoring: {
    id: '0e8fbf33-c82d-4332-8e40-d32f93d8c939',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  HydrateAnswersTopicsAsync: {
    id: 'c12475ea-b7f2-41d3-acc8-959d517f2ffb',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ImageBlobification: {
    id: '53f31e52-2976-4f31-b87b-e5a2f85c4f69',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ImageCompressionWeb: {
    id: 'fcb962de-8faa-4ac2-9240-8396d9bb96e3',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  IntelligentImporterBulkDelete: {
    id: '7604b46b-048c-4797-ab0e-5f2b60961dbf',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  IntelligentImporterDeleteOnPublish: {
    id: 'fc579934-8971-4492-b9fc-6badebc9f093',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  IntelligentImporterCopilotAdoptionCommunities: {
    id: 'ff0b3586-e8d6-4e7a-88ea-e9beafa8e888',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  KnowledgeBespokeCommunity: {
    id: '992716ec-e54a-48cd-9885-996aaacc3cd3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderAudienceFeed: {
    id: '45242ffb-565d-45c3-9aec-cead8078233c',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LeaderDashboard: {
    id: 'a359d84d-2676-4683-b255-48660a52ab10',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersViewDelegation: {
    id: '0598fa62-01bf-4ec2-9a26-1b049810999d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadershipCornerPinnedPosts: {
    id: 'ea5334fb-dfb9-4eb0-a15e-f2569df04eba',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderGroupsAddAsync: {
    id: 'c67be930-601d-40f2-a300-b3027ea21b10',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersAudienceM365Support: {
    id: 'bc62da45-9b8f-493a-940f-fc99ef2bddbb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderManagementActivityLog: {
    id: 'a4c3c54b-2bbf-4890-9129-1a45d59a3297',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderOptionWebpart: {
    id: '1209c849-4fab-4a02-b0fc-1744d592d649',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LightboxFollowUsers: {
    id: 'd34c34e0-815c-4133-a17d-fe181895cf4d',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LimitConversationMoveSettingsAndFilter: {
    id: 'd9aa165e-da2d-4f08-a641-94bad06aa4e5',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LiveEventsScaleLoadPerf: {
    id: '2a6b1ca4-5734-44b0-8d45-6b1c28976a51',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LiveEventSortingChangeEnabled: {
    id: '33d94caa-e259-4c4f-be93-656012fe9b84',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LoadFeedDataWhileRouting: {
    id: '9b715056-ccf7-49f7-8cc8-a02ad138ce80',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LoadThreadDataWhileRouting: {
    id: '18ee7168-7103-4b28-b005-3285d0cc356e',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LogProtobufEvents: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RestrictPostingAnyGroupRollout: {
    id: 'de3b6c60-f521-4e7d-b89a-2c8d19d81785',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  M365CopilotAdoption: {
    id: '344b3d2d-7100-41e9-a7b2-5a7c7d493a6f',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  M365CopilotAdoptionRelatedQuestions: {
    id: '5305e6b4-d2a2-4462-9091-c682d4c154d0',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  M365CopilotAdoptionSuggestedMembers: {
    id: '94573c25-cadd-485f-868f-d5e91d8ec8a4',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  M365CopilotAdoptionTopQuestions: {
    id: '7bd82aab-270b-4045-b8e2-45da2e06ec60',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MicrosoftDesignerApp: {
    id: '49497680-16e2-43f4-bc69-0363063618c2',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModulatorGroupSuggestionsEnabled: {
    id: 'bfd3fd32-6e3c-41c0-a792-8962dab5d283',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModerationDetectedConversations: {
    id: '2f6e4e87-e664-4111-aba0-9d4ff6a69b20',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModerationThemeDetectedEmailNotification: {
    id: '2be957ef-2bdc-419a-aea6-f31d45a37731',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DigitalSafety: {
    id: 'bd30fd55-3056-49dd-99cf-8f961a8134e1',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOAdminToggle: {
    id: 'a466846a-de55-4370-ada6-6f172ac23126',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOStoryline: {
    id: '773bacc9-2f0d-41f8-ae8d-d8528c0ef1bc',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOBadge: {
    id: '1709ba31-c004-438a-bc2d-98172009fe26',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOBlendedInbox: {
    id: '50746bf4-b609-43de-9287-c67c52b25d7d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOCampaigns: {
    id: 'ecb84501-2887-4ffe-8b66-bf00c1eca68d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOCommunity: {
    id: 'e34e6b47-9c6f-4ce9-87c5-f171f05b1e9c',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOGraphVNextResolvers: {
    id: 'ddee0f75-88c7-4f47-93bd-d9d305dc8fd8',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOOpenResourceUrl: {
    id: '7ff8ed08-b404-4f8d-929a-902f43e50edb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOPolicyEngageAdminPortalPage: {
    id: '8d19e764-4203-47aa-945b-d3c1b656593f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EnablePermalinkDeeplink: {
    id: '76203ecf-f92b-43ef-8a76-5aad974ac86b',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MultiTenantOrganization: {
    id: 'eaef51f5-5324-4fff-a9be-189da3de3a89',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MultiLanguagePublisher: {
    id: 'a73891cb-6522-4174-9099-3bf54074d633',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MutedVideoAutoPlay: {
    id: 'c558f27c-f518-4e88-a15a-e7a039ac9345',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MobileCrossSellThreadViewV2: {
    id: '38b66b3c-4070-49d7-8503-67c0b615bb0f',
    projectTeam: 'YammerClients',
    treatments: ['control', 'qrCode', 'banner', 'coachingTip'],
    defaultTreatment: 'control',
  },
  MyGroupsAdminOfFilter: {
    id: 'b1be92fd-10e9-404b-9ea0-9c987e54a8eb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  NestedBestReply: {
    id: 'ed32c679-bc95-4b36-a917-012c9a4e132b',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  NetworkInsightsHRFilters: {
    id: '6a91be41-eb37-4dc2-9930-35648a105963',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  NetworkQuestionsInConversations: {
    id: 'b844c74d-8d80-41f4-968d-ca676ec73a76',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  NotificationsReplatform: {
    id: 'c6f522b0-9245-4ff8-82cf-a125c13d21a6',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OneCameraV3: {
    id: 'b4c0de9d-144f-4dd5-9357-f6453c73d48b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnePlayer: {
    id: '02c63db1-443a-42f4-97b6-f2346727994d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnePlayerV2: {
    id: 'cd2b3546-0d46-4de1-8cac-bba88db3ac61',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnePlayerNative: {
    id: 'c014fb1e-2d91-47e7-9d63-005fa8fd0490',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWADigestsThreadsReduction: {
    id: 'f5a71cb2-06c1-4d85-bc16-2ed0f71adb6d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OdspFilePickerType: {
    id: 'a316df71-760f-47ec-97fd-84e11f14017c',
    projectTeam: 'YammerClients',
    treatments: ['control', 'group', 'onedrive'],
    defaultTreatment: 'control',
  },
  OfficeTopics: {
    id: '859373f9-fd86-46e8-a452-6ee50d68c6b6',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OpenPublisherWithModal: {
    id: '09f483a5-d75b-4ecc-840a-604411989c70',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OpenPublisherWithCopilotModal: {
    id: 'd3ce66e7-7c33-4f42-a167-9b275a20cd15',
    projectTeam: 'YammerClients',
    treatments: ['control', 'home', 'group_storyline_campaign', 'home_group_storyline_campaign'],
    defaultTreatment: 'control',
  },
  PeopleSuggestion3SV3: {
    id: '5d873e2e-b60c-43d5-801a-716cce0894bc',
    projectTeam: 'YammerClients',
    treatments: [false, 'enabled'],
    defaultTreatment: false,
  },
  PinnedFiles: {
    id: 'b2b7ae31-803f-42f8-833b-5d99489cc3a5',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PollsSchedule: {
    id: '91f8c0a8-b9e3-4028-96e7-eb9facd7f02c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PostOnBehalfOfCommunityHomePublisher: {
    id: '2d1a61c7-1957-42ab-94b6-faa67b639669',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrefilledDefaultAudience: {
    id: 'a7c7ce2f-c586-40c7-abae-8d2c916a3572',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrivateReplies: {
    id: '4696293a-9b33-426a-8984-cc326bc9b5df',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrivateRepliesAMA: {
    id: '88afd108-c163-46bc-b026-3cf910630eee',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrivateRepliesEditPendingThreads: {
    id: 'ea9fa260-f58e-4379-986e-b3940947821e',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrivateRepliesQnANotifications: {
    id: 'f592f305-6a46-45a0-b899-9b0d3039ac61',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherAbandonmentOCVSurvey: {
    id: '96eea534-dc14-4e29-a10b-cd4c3ace6545',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherClientSideSaveDraft: {
    id: 'ba54ff05-52c8-4c70-b38d-181f95a0d9d6',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherSuggestedTopics: {
    id: 'df2bddf4-61dd-4bc5-a1c7-778939fe36ae',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuestionsQueue: {
    id: '2c93f569-5660-4f0d-8f86-d308cba0cf9f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherV2: {
    id: 'fe1407c2-95b1-41f5-ace7-e2b62dfc660e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuestionTitles: {
    id: '4e5b9a92-cd36-4477-95bd-d4118d8ff432',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuestionTitlesV2: {
    id: 'a981220d-4f03-4a3b-97e0-05dd9a1a9250',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuestionTitlesV3: {
    id: 'f1aeb59d-9236-4bb4-bb70-de6662f621eb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuickNavManageMyThings: {
    id: '6a005258-30ee-443e-9b6e-ff1024e2b8c0',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PWALegacyBrokenExperience: {
    id: 'ede9763e-cfe8-4d4b-806f-21dd96be8409',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PWALegacyDeprecation: {
    id: '7d658113-c6ca-49b7-aa5b-dc53c76e3a14',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ReactionSimplification: {
    id: '7119895f-2b5b-4e09-93a4-a745c0c96c48',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ReadOnlyMode: {
    id: 'da33e692-30d5-4ade-b69f-f0b062b143e5',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RecommendationBarCampaignFollowBtn: {
    id: 'c4883b79-4b7b-404e-8fa1-a1cae2c80621',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RemoveDelegateAPIMigration: {
    id: '1ac0b446-cdf0-4668-8e65-d9b9de544967',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RemoveTopicsSDKDependencyForVivaTopicsInFeeds: {
    id: '4992995f-b0d5-4b77-997c-703e977eda4d',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ReportConversationMigration: {
    id: '3707513b-3ff6-4f15-80ee-61a53a476c88',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ReportLongAnimationFrameTiming: {
    id: 'e3658634-6a3f-4760-9f41-82e8e5eeece0',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RestrictedUser: {
    id: '1bafa77b-67ff-408b-8e35-7ce00fc3a561',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RoleBasedFRE: {
    id: '6a88d980-c993-4549-8559-d07a184527a7',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  SearchAllResultsTab: {
    id: '902d9dbc-2c49-430e-9ad9-8e8bd62b4fdc',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SearchDiscoverabilityFRE: {
    id: '179aa02b-969b-4288-b812-d2998c9b74e1',
    projectTeam: 'YammerClients',
    treatments: ['control', 'treatmenta', 'treatmentb'],
    defaultTreatment: 'control',
  },
  SearchFiltersRefresh: {
    id: 'b8d58aaa-66e4-4d79-98c4-baee0c2b45cd',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SearchAutocompleteResultsGroupFirst: {
    id: '208487c1-fa39-498a-9cde-95d3a88384ab',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SearchWithCopilot: {
    id: '01fd6d4e-88ea-4f3b-aab2-58c4aa4dde2b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SeededLeader: {
    id: 'bbbff046-d8f5-4177-ae8b-94360f942615',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ServerSharePointWebLinks: {
    id: 'cb6da583-69f6-422d-ba1c-0d1bf9af85e8',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ShareAMAPoboToStoryline: {
    id: '6649bf4b-142b-4061-a46c-a1b2103d6551',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointVideoLinkPreviews: {
    id: '28323fd7-5caa-420d-998d-88f9224d9698',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointTempAuthUrlDeprecation: {
    id: 'e74e2593-fcd8-4b5c-999f-27f355a8aa17',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointTempAuthUrlDeprecationByTenant: {
    id: '1d004a2d-5c0e-4948-b13b-56a8aa69a3cf',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ShowUserCoverImage: {
    id: '1b55e8eb-36f3-4022-ac2c-2588d3869931',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SimplifyExpertVerification: {
    id: '6e3a017e-174f-42f3-91ef-de1fdf9d400b',
    projectTeam: 'YammerClients',
    treatments: ['control', 'inline_nudge', 'with_celebration', 'full_loop'],
    defaultTreatment: 'control',
  },
  SmallFileUpload: {
    id: '8c7e99ba-f485-46ea-9c15-963168beaf73',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SplitDataAndPresentationComponents: {
    id: '7bab3ae5-1adc-46f4-ba94-d301aa631953',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  Stories: {
    id: '06ca9171-c49a-4437-87ff-db71db80eca0',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesPostOnBehalfOfEnabled: {
    id: '466fb696-01ba-46f9-b815-5841afd683d5',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesV2Cards: {
    id: '8ce624f9-6d36-46be-a1b8-66a4e9200e0c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAnnouncementAudienceChannelsConfigEnabled: {
    id: '815edf06-def6-4e9e-93f5-dee926e9c4ad',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementNotificationUrgency: {
    id: '4915afb3-27fd-4dac-8a02-dd6cc20310c7',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAnnouncementTeachingBubbleAndDisableInfobar: {
    id: '8714e391-0b32-4202-9c11-5da24443b1c5',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementTeamsEmailChannelsEnabled: {
    id: 'bda9c5a1-3e58-40ce-8525-04605ef7fb28',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAsDefaultOnHomePublisher: {
    id: '607d8f62-67cc-46dd-8ab9-05dfe7093edf',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDefaultHomeFeedPublisherShortv2: {
    id: 'ffde70ab-2ccf-4025-9cb2-6b386c65f7a1',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDefaultHomeFeedPublisherLongv2: {
    id: 'cd8b5099-2742-4e28-bf15-e2170c394bd5',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDirectAndDigestRebrand: {
    id: 'a9c87cbf-fbab-45b9-b081-0d60f239ce37',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineFeatureConversation: {
    id: 'd7bd2914-15a3-4557-a105-46f340f6ee97',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineFollowBack: {
    id: 'e134b15f-4875-4f81-b180-a2777912074d',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineFREVivaEngage: {
    id: 'af384543-6d30-4364-86ed-a119538de985',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineMediaPost: {
    id: '289e4542-d271-4c2d-82bd-58aa4c43cbf0',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineMediaPostGA: {
    id: '25c564cd-65ef-485c-963f-9fd4bc62222b',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePerUserControl: {
    id: '974480fc-4e4d-472a-8785-aead29cab958',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePublisherSettingsNetworkCall: {
    id: '968afe62-d291-42c8-8816-9b5d99d86cfa',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePublisherCoachingTips: {
    id: '31c06d83-f8eb-4423-a704-9294705c5ab5',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherTipsLongV3: {
    id: '6ccecbf9-797e-4289-b9ef-1976e6e78cd3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherTipsShortV3: {
    id: 'aaaa837e-517c-491e-b691-512b2b14d6b3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadCoachingTips: {
    id: 'd02b84c7-32c3-42f4-8edc-a9116e7054cc',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadTipsLongV3: {
    id: '6980c260-9492-4754-a800-c0caf6bada91',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadTipsShortV3: {
    id: '151b08a8-8224-4a4b-803a-d768bdfa2d72',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StreamLiveEventDeprecationExtension: {
    id: '327f469b-604b-496a-9935-76ae9d9971e1',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ExternalNetworksAdminPage: {
    id: 'c4182bd6-102e-4a93-b99e-f858b6aeb838',
    projectTeam: 'YammerClients',
    treatments: [0, 1, 2, 3, 4],
    defaultTreatment: 0,
  },
  SuggestedThemes: {
    id: 'b6b15be7-6747-40e9-85ca-98b400a3900c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SystemInitiatedEngageFeedback: {
    id: 'ffa292ef-515c-4659-ad4a-ec27203372de',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TBENestedAuthAppSupport: {
    id: 'b3151e53-ea5c-4627-835a-1c1915f16219',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TBEBackgroundLoadApp: {
    id: 'f5cd9cbd-1bfc-48fd-b3c7-5716afb850cc',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBackButton: {
    id: '78187586-38f7-4984-b4e4-b8b9ea9a06d5',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsClientDataLayer: {
    id: '97d45c1b-5a03-4a88-8462-828883433b80',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesCommunityFeatures: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesLastReadBar: {
    id: 'c2c26c2f-8454-45a9-96b1-3961765ad7c7',
    projectTeam: 'YammerClients',
    treatments: [false, true, 'diagnostics_last_read_bar'],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesEvents: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: ['off', 'on', 'teams_storyline_only'],
    defaultTreatment: 'off',
  },
  TeamsBrandedExperiencesOpenStorylineTab: {
    id: '8c6b93a1-15bf-466c-83e1-29f6f39e92b3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesServiceWorker: {
    id: '305440a3-91cc-4ad2-aba1-f78cf9c6d5d1',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesUseEngageCoachmarks: {
    id: '00b52e87-edbe-421e-a199-95a3aa4304d8',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesFREShowLearnMore: {
    id: '8838667e-0f4d-45aa-92cb-7a58c69b51ae',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesFilesTab: {
    id: '13c02fd2-c546-4d75-9020-31fc16fabd40',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsFocusCommandsInEngageApp: {
    id: '0a2c91a5-5b31-412b-9c97-05f839816a93',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingAccess: {
    id: 'a1e4ad9b-3252-476f-8d36-d1ab593eea1e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingArchiveFeature: {
    id: 'dbc04bfd-d532-4733-9f28-b8989a797031',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingDisableReactionsOption: {
    id: 'd3c388f4-9b2a-4dc5-859f-e445aaf19428',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingMaskIdentitiesBanner: {
    id: '4e3e9c95-61f3-4696-9261-2f133c295417',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMetaOSNestedAuthAppSupport: {
    id: '8c9395de-1499-4da1-b9b8-f4781b2cbf5a',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsPageLoadSuccessTiming: {
    id: '82d3d388-d3f5-41a5-881f-8663a54bea52',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAMessageReactions: {
    id: '5c5e3512-c64c-49c7-9e4c-80196146e719',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAFeedReset: {
    id: '843e64a0-d562-462b-bc22-14404b918cad',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAPostAsModerator: {
    id: '407320c5-fa3c-46f9-9865-08efd680ba7f',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAPostAsModeratorNotifications: {
    id: 'f28bf19d-cee1-497a-9796-d3251d619ba8',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAPostAsModeratorSenderDetails: {
    id: '24204a26-d022-4e4e-a732-4be74b1e5a67',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAReloadMeetingOnCacheResume: {
    id: '5f85a1f7-973e-4f11-ac3a-dcea1e76bcdb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAThreadUpvote: {
    id: '579fb564-0151-42d3-9416-4f9e351770a1',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAVivaEngageAmaRedesign: {
    id: '2dd99733-c6c8-4672-b88b-0f2f87519016',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnANestedAuthAppSupport: {
    id: 'feb5e4bb-2d8f-4d84-9009-5c0b8101c495',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAUXUpdatesDeprecated: {
    id: 'd5fb4cfa-f8df-4ff6-9e44-d00b38ce728c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsTownhallEventInVivaEngage: {
    id: 'ae8b760b-8ed5-4477-b1b0-30715384c65f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsUserInitiatedEngageFeedback: {
    id: 'b0f39467-d849-4e66-b919-0227eb9cfe58',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ThirdPartyCookieFix: {
    id: '030bb639-7605-4387-9c94-e42e5845af82',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ThreadCopyLinkV2: {
    id: 'a7d57c9e-704f-488d-8ab9-a0dfad8c42dd',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TopicSegmentationV1: {
    id: '6f0c309a-e720-43e8-bcf3-02929c7473bd',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UCBSquareDesign: {
    id: 'd5db8c8b-cd61-4e4f-ad3c-7129969f7c78',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  UseBatchedFiles: {
    id: 'f39078e3-d850-4dac-b19b-bcf38ea44ef3',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserGroupsFromGrouper: {
    id: 'e745b9c1-095b-45f6-a2aa-a4989bb2c0d8',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UserInitiatedEngageFeedback: {
    id: '4a4e5a8a-136b-48f9-a62c-d9712b84bf64',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UserSettingsNotificationsLoader: {
    id: 'bfbf31a4-b608-4f2b-836f-84dffb94441c',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UserSettingsPageCrossPlatform: {
    id: 'a6f0f9f9-6edb-49c0-8651-f57b5687bce3',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  UniversalCreateButtonV3: {
    id: '62ddec3f-234c-4557-83d7-b10d286fb0eb',
    projectTeam: 'YammerClients',
    treatments: ['control', 'blue', 'white'],
    defaultTreatment: 'control',
  },
  UniversalCreateButtonWithQuestion: {
    id: '9837e6e8-f692-44de-8c18-bd0d9e692eeb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VerifiedAnswers: {
    id: 'bb3a70aa-749e-4c6f-aa19-49fa7505d8fe',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TranslationOverrides: {
    id: '63abdaf4-a45b-4175-925a-e7688c9c89dc',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enable_vietnamese', 'enable_all'],
    defaultTreatment: 'control',
  },
  VivaAppBar: {
    id: '18e154dd-b32a-42b8-b555-ef2bfb161823',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAdminBanner: {
    id: 'f81f90cd-46c2-4caa-990b-f91f448ca776',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaBestAnswerRedesign: {
    id: '88c2eece-1e6a-46eb-9ba4-b7deed18c318',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaRebrand: {
    id: 'ee6fc432-faa6-44ae-9d12-bf4daf22e167',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EventAnonymousPosting: {
    id: '1e991dfc-1c61-4ef3-bd31-9bdfb2405444',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrivatePremiumEventCreation: {
    id: 'e07f8662-6047-497a-a4b4-cefc52a7b911',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PremiumEventExperience: {
    id: 'f0e76685-84e0-4669-b373-83c694f6e96b',
    projectTeam: 'CrossPlatform',
    treatments: ['none', 'all', 'all_meeting', 'storyline_all', 'storyline_meeting'],
    defaultTreatment: 'none',
  },
  VivaEngageCoverImage: {
    id: '52589660-bd2e-495b-8264-3729d18bbbb5',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageDeepLinkFromOWA: {
    id: '2809a765-1843-4189-9460-cb296610a0f7',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageGlobalCopilot: {
    id: '19bfe564-82b3-45f6-bd80-ef4f63d5aa6e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAugLoopEnvironment: {
    id: 'f11bbd96-d6c3-46ab-866c-1662d9bfed90',
    projectTeam: 'YammerClients',
    treatments: ['int', 'dogfood', 'prod', 'test', 'msit'],
    defaultTreatment: 'prod',
  },
  VivaEngagePremium: {
    id: '7967125b-c339-443b-927f-c7f0a908ae30',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageQnAFastFollow: {
    id: 'cf9819bf-aa91-4d40-a5f6-f3ad28e3be41',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCollapsiblePanelRecommendations: {
    id: '2cc0b58b-35a0-47d8-aee4-51c37f7aef0b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotBE: {
    id: '8d51b16b-0cf0-414e-b3d9-5ca3bb56b443',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageCopilotDebug: {
    id: '1eeb6174-f2b4-41eb-b818-77f45b91042f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotCatchUpPlugin: {
    id: '194d6cb3-6af5-4652-ac02-d31e081da95a',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotWAGpt4: {
    id: '0453b07b-59e0-4345-8514-d19e436d946f',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageCopilotWAPersonalized: {
    id: '44420984-e67f-4c5b-a5c6-7b43faaef021',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageOfficeAICopilot: {
    id: '0a99b068-262e-4c63-a7a0-42a149a33ba0',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageLC: {
    id: 'f01b8142-2f47-492c-a640-b3836b8b7afc',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaLeadershipChronoFeed: {
    id: '0bc20bf9-4197-40fe-b262-912c9bebf58b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaLeadershipCuratedFeed: {
    id: '3f8817dc-c4c0-464c-a2f2-34b5d1b0fd81',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageRebrandingBanner: {
    id: '9cee3a74-b547-43a7-939d-a0aa9b5a9de7',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageRebrandingAdminBanner: {
    id: 'd976eaa7-08d3-441b-9ee6-b48a05f4d6ed',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageSearchPlugin: {
    id: 'a882b166-4f27-44fd-8b54-6f51e984943b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageTeamsLiveEventMobile: {
    id: '6f2f97ba-ec37-4508-8b12-fbbf3e648186',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaGoals: {
    id: '5264c978-4a61-4f32-a6eb-019c755ea0a4',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaGoalsConfig: {
    id: '09431989-cb2b-47d2-bc54-71b25a0652d9',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaGoalsOverride: {
    id: '16463115-cfd2-4ab6-85b6-507f554577ff',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  NoWFMessageBodyInGroupMessageCreationResponse: {
    id: '9c4d957c-94b1-43d8-bcc6-84a14db0cde2',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MinimalWFPayloadOnReplyPosting: {
    id: '4def6d5d-ad49-4be4-8d63-dede011d672f',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MessagesReactionsAPI: {
    id: '32f18ade-ec9f-478d-aa5a-fa2baa4e282d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: 'false',
  },
  OptimizedReactionsFetching: {
    id: '5fc95130-6444-4e47-92fc-f3ca5a16ac6f',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UnseenThreadStarterInInbox: {
    id: '6efec7a9-947a-4e04-a697-4d71dbd7c7af',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  YamJSEOLUnsubscribe: {
    id: '6138ebbe-ee4f-4823-b6ed-58d43df6a7b1',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleSuggestionBar: {
    id: '5b03cdde-e928-4b07-9d1c-e99354559a4e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleTableofContents: {
    id: '158f5bd7-a8ca-4657-b9e7-93ff6c38d56c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
};

export type ExperimentConfigs = Record<Experiment, ExperimentConfig>;

export type ExperimentTreatments = Record<Experiment, ExperimentTreatmentValue>;

export const defaultExperimentTreatments: ExperimentTreatments = (
  Object.keys(experimentConfigs) as Experiment[]
).reduce(
  (acc: ExperimentTreatments, key: Experiment) => ({
    ...acc,
    [key]: experimentConfigs[key].defaultTreatment,
  }),
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  {} as ExperimentTreatments
);

export interface EcsExperiments {
  readonly treatments: ExperimentTreatments;
  readonly treatmentsFromService: Partial<ExperimentTreatments>;
  readonly treatmentOverrides: Partial<ExperimentTreatments>;
}
